import { AwsUi } from '../../../core/runtime/src';
import { RadioButton } from './radio-button';
import { RadioGroupController } from './controller';
import { generateGroupName } from './utils';
export var RadioGroup = AwsUi.__addComponent('awsui-radio-group', {
    releaseStatus: 'stable',
    callbacks: {
        initialized: function () {
            this.__controller = new RadioGroupController(this, this.node);
            this.__generatedName = generateGroupName(this.__componentName);
        }
    },
    properties: {
        // Value of the checked button.
        value: {
            type: 'string',
            onChange: function () {
                this.__controller.handleValueChange();
            }
        },
        // Use this property to name the radio buttons yourself. If not provided, the radio group will
        // name buttons automatically.
        name: {
            type: 'string'
        },
        // List of radio buttons definitions. Use the aria properties only if you have a shared form field label
        // and custom description/hint text on the form field level. Make sure you refer to the radio label
        // as well from the aria-labelledby, otherwise it will not be read.
        //
        // Example:
        // ```
        // [{
        //   value: "one",
        //   label: "One",
        //   description: "First option"
        // }, {
        //   value: "two",
        //   label: "Two",
        //   description: "Second option",
        //   disabled: true
        // }]
        // ```
        items: {
            type: 'array',
            itemTypes: ['RadioGroup.RadioButtonDefinition']
        },
        // Adds aria-required on the group. This will only be applied if the group
        // is wrapped in an awsui-form-field
        ariaRequired: {
            type: 'boolean',
            announceValue: true
        }
    },
    events: {
        // Fired when the user selects a different radio button.
        // The event `detail` contains the current `value`.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'RadioGroup.ChangeDetail'
        }
    },
    render: function (m, h) {
        var _this = this;
        return this.items.map(function (def, index) { return (AwsUi.__createElement(RadioButton, { __managedByRadioGroup: true, name: _this.name || _this.__generatedName, checked: _this.value === def.value, value: def.value, label: _this.renderToMithril("radio-button-label-" + index, def.label), description: def.description ? _this.renderToMithril("radio-button-description-" + index, def.description) : '', disabled: Boolean(def.disabled), controlId: def.controlId, ariaLabel: def.ariaLabel, ariaLabelledby: def.ariaLabelledby, ariaDescribedby: def.ariaDescribedby })); });
    },
    wrapperSupport: {
        ngModel: {
            value: 'value',
            event: 'change'
        }
    }
});
//# sourceMappingURL=radio-group.js.map